import React, { FC } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { PaymentMethodCard } from "../../../../Components/PaymentMethodCard/PaymentMethodCard";
import messages from "./messages";
import { IPaymentMethod } from "@modules/PaymentProcessing/services/paymentMethods";
import {
  ICardNetwork,
  PaymentMethodType,
} from "@modules/PaymentProcessing/types";

interface Props {
  onClick: (paymentMethod: IPaymentMethod) => void;
  disabled?: boolean;
  isUserFrench?: boolean;
}

export const CreditCardPaymentCard: FC<Props> = ({
  onClick,
  disabled,
  isUserFrench,
}) => {
  const cardNetworkIcons: ICardNetwork[] = [
    "mastercard",
    isUserFrench ? "cartesBancaires" : "americanExpress",
    "visa",
  ];

  return (
    <PaymentMethodCard
      title={<FormattedMessage {...messages.creditCard} />}
      onClick={onClick}
      cardNetworkIcons={cardNetworkIcons}
      value={PaymentMethodType.CREDIT_CARD}
      disabled={disabled}
      data-testid="credit-card-payment-link"
      disabledModalTitle={<FormattedMessage {...messages.noCreditCard} />}
      disabledModalContent={
        <FormattedMessage
          {...messages.creditCardTransactionsAreNotSupportedForThisService}
        />
      }
    />
  );
};
